module.exports = __webpack_public_path__ + "assets/images/project/kranji-marshes/01.jpg?v=8f5b35a8";